import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { RightOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import './Modules.scss'
import { addModule } from '@store/actions/index'
import { useTranslation } from 'react-i18next'
const mapStateToProps = state => ({
  activeId: state.panes.activeId || 'root',
})

const mapDispatchToProps = dispatch => ({
  addModule: (moduleName: string, pid = 'root') => {
    dispatch(addModule(moduleName, pid))
  },
})

const Configs = props => {
  const { t } = useTranslation()
  const moduleList = useMemo(() => {
    return [
      { title: t('anchorTabs'), key: 'AnchorTabs' },
      { title: t('imageBox'), key: 'ImageBox' },
      { title: t('productList'), key: 'ProductList' },
      { title: t('videoBox'), key: 'VideoBox' },
      { title: t('textBox'), key: 'TextBox' },
      { title: t('mixedBlocks'), key: 'MixedBlocks' },
      { title: t('customTitle'), key: 'CustomTitle' },
      { title: t('searchBar'), key: 'SearchBar' },
      { title: t('conference'), key: 'Conference' },
      { title: t('noticeBar'), key: 'NoticeBar' },
      { title: t('combinationList'), key: 'CombinationList' },
      { title: t('custom'), key: 'Block' },
    ]
  }, [t])

  return (
    <div className="module-container">
      <h2 className="module-header">{t('module')}</h2>
      {moduleList.map((item, index) => {
        return (
          <div
            key={`module-items${index}`}
            className="module-items"
            onClick={() => props.addModule(item['key'], props.activeId)}
          >
            <Button type="default" className="moduleBtn">
              {item['title']}
              <RightOutlined />
            </Button>
          </div>
        )
      })}
    </div>
  )
}
export default connect(mapStateToProps, mapDispatchToProps)(Configs)
